module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types"}
// module id = 3
// module chunks = 0